import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import CustomMultiSelect from '../../../../Shared/CustomMultiSelect';
import { partitionFieldsAssignUnassign } from './helpers';

const TeamsAssign = ({
  options,
  defaultValue,
  isDisabled,
  className,
  onChange,
  title,
}) => {
  const [teams, setTeams] = React.useState([]);

  const getTeamOptionWithoutHyphen = (label, value) => ({ label: label.replaceAll('—', ''), value });
  const getTeamOptionWithHyphens = (id, name, index) => ({ label: `${'—'.repeat(index)} ${name}`, value: id });

  const parseNestedTeams = (teamsToParse, index = 0) => {
    let tempTeams = [];
    teamsToParse.forEach(({ id, name, children }) => {
      if (children.length) {
        tempTeams = [
          ...tempTeams,
          getTeamOptionWithHyphens(id, name, index),
          ...parseNestedTeams(children, index + 1),
        ];
      } else {
        tempTeams.push(getTeamOptionWithHyphens(id, name, index));
      }
    });
    return tempTeams;
  };

  const selectOptions = useMemo(() => parseNestedTeams(options)
  // eslint-disable-next-line
    , [JSON.stringify(options)]);

  const onSelectChange = (val) => {
    setTeams(val);
    onChange(partitionFieldsAssignUnassign({
      currentData: defaultValue,
      updatedData: val,
    }));
  };

  React.useState(() => {
    setTeams(defaultValue.map((val) => (getTeamOptionWithoutHyphen(val.name, val.id))));
  }, []);

  return (
    <CustomMultiSelect
      title={title}
      type="text"
      onChange={onSelectChange}
      value={teams.map(({ label, value }) => getTeamOptionWithoutHyphen(label, value))}
      isDisabled={isDisabled}
      options={selectOptions}
      className={className}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
    />
  );
};
TeamsAssign.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape),
  defaultValue: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.string,
};

TeamsAssign.defaultProps = {
  onChange: () => {},
  defaultValue: [],
  options: [],
  className: '',
  isDisabled: false,
  title: 'Teams',
};

export default React.memo(TeamsAssign);
